import Aura from '@primeuix/themes/aura';
import { ColorScale, definePreset, palette } from '@primeuix/themes';

export const COLOR_PALETTE = {
  primary: {
    50: '#fff8e8',
    100: '#feefc5',
    200: '#fde08a',
    300: '#fcd14f',
    400: '#fbc02f',
    500: '#f9a41f', // primary
    600: '#e28f12',
    700: '#ba7a13',
    800: '#8f5d12',
    900: '#69440f',
    950: '#3d2607'
  },

  secondary: {
    50: '#f7f3eb',
    100: '#ebe1cb',
    200: '#d9c08f',
    300: '#c89f54',
    400: '#ba8630',
    500: '#ba7a13', // secondary
    600: '#9f6910',
    700: '#7d530d',
    800: '#5f3f0a',
    900: '#412b07',
    950: '#241703'
  },

  surface: {
    0: '#ffffff',
    50: '#f5f5f5',
    100: '#e8e8e8',
    200: '#d1d1d1', // text-color
    300: '#b5b5b5',
    400: '#8f8f8f',
    500: '#6b6b6b',
    600: '#474747',
    700: '#2a2b2d',
    800: '#17181a',
    900: '#0d0e0f', // background-color
    950: '#080909'
  },

  info: {
    50: '#eef6f7',
    100: '#d7e9ec',
    200: '#b0d3d9',
    300: '#89bec7',
    400: '#6fa9b7',
    500: '#62929e', // link-color
    600: '#58a4b0',
    700: '#457f89',
    800: '#33626a',
    900: '#23474d',
    950: '#13272b'
  },

  success: {
    50: '#eefbf7',
    100: '#d2f5e8',
    200: '#a8ead5',
    300: '#79ddbF',
    400: '#49cfa8',
    500: '#22b88b',
    600: '#189b74',
    700: '#137b5c',
    800: '#0f5c45',
    900: '#0a3f30',
    950: '#05231b'
  },

  warning: {
    50: '#fff8e8',
    100: '#feefc5',
    200: '#fde08a',
    300: '#fcd14f',
    400: '#ffb84d', // highlight
    500: '#f9a41f',
    600: '#e28f12',
    700: '#ba7a13',
    800: '#8f5d12',
    900: '#69440f',
    950: '#3d2607'
  },

  error: {
    50: '#fff1f0',
    100: '#ffd9d6',
    200: '#ffb3ad',
    300: '#ff8b82',
    400: '#f46d63',
    500: '#d94b3d',
    600: '#b53a2f',
    700: '#8d2d24',
    800: '#68201b',
    900: '#451411',
    950: '#250908'
  }
};

export const MyTheme = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        semantic: {
          primary: COLOR_PALETTE.primary as ColorScale,
          secondary: COLOR_PALETTE.secondary as ColorScale,
          info: COLOR_PALETTE.info as ColorScale,
          success: COLOR_PALETTE.success as ColorScale,
          warning: COLOR_PALETTE.warning as ColorScale,
          error: COLOR_PALETTE.error as ColorScale
        }
      },
      dark: {
        semantic: {
          primary: COLOR_PALETTE.primary as ColorScale,
          secondary: COLOR_PALETTE.secondary as ColorScale,
          info: COLOR_PALETTE.info as ColorScale,
          success: COLOR_PALETTE.success as ColorScale,
          warning: COLOR_PALETTE.warning as ColorScale,
          error: COLOR_PALETTE.error as ColorScale
        }
      }
    }
  }
});
